/*! @preserve
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Giulio Canti
 *
 */

import t from './index';
import templates from './template/index';

////@ts-ignore
t.form.Form.templates = templates;

export default t;
